// const React = require("react");
// import "tailwindcss/base.css"
// import "tailwindcss/components.css"
// import "tailwindcss/utilities.css"

import "@fontsource/poppins"
import './src/styles/global.css'
import React from 'react';
import { ParallaxProvider } from 'react-scroll-parallax';
import { initAnalytics } from './src/functions/Analytics/Analytics';

let codeCopyHandlerRegistered = false;

const initCodeBlockCopy = () => {
  if (typeof document === 'undefined') return;
  if (codeCopyHandlerRegistered) return;
  codeCopyHandlerRegistered = true;

  document.documentElement.setAttribute('data-til-copy-ready', 'true');

  document.addEventListener('click', async (event) => {
    const button = event.target?.closest?.('[data-til-copy]');
    if (!button) return;

    const wrapper = button.closest('.til-code');
    const codeElement = wrapper?.querySelector('.til-code__code');
    if (!codeElement) return;

    const codeText = codeElement.textContent || '';
    if (!codeText) return;

    try {
      if (navigator?.clipboard?.writeText && window?.isSecureContext) {
        await navigator.clipboard.writeText(codeText);
      } else {
        // Deprecated fallback for older/non-secure contexts where Clipboard API is unavailable.
        const textarea = document.createElement('textarea');
        textarea.value = codeText;
        textarea.setAttribute('readonly', '');
        textarea.style.position = 'absolute';
        textarea.style.left = '-9999px';
        document.body.appendChild(textarea);
        textarea.select();
        const copied = document.execCommand('copy');
        document.body.removeChild(textarea);
        if (!copied) throw new Error('copy failed');
      }

      button.dataset.state = 'copied';
      button.textContent = 'Copied';
      window.setTimeout(() => {
        button.dataset.state = '';
        button.textContent = 'Copy';
      }, 2000);
    } catch {
      button.dataset.state = '';
      button.textContent = 'Copy';
    }
  });
};

export const wrapRootElement = ({ element }) => {
	return (
	  <ParallaxProvider>
		{element}
	</ParallaxProvider>
	);
  }

// Runs once in the browser before React hydrates, so PostHog is ready as soon as
// the cookie banner grants consent. It stays dormant until then.
export const onClientEntry = () => {
  initAnalytics();
  initCodeBlockCopy();
};

// Logs when the client route changes
// module.exports.onRouteUpdate = ({ location, prevLocation }) => {
// //   console.log("new pathname", location.pathname)
// //   console.log("old pathname", prevLocation ? prevLocation.pathname : null)
// }

// module.exports.onInitialClientRender = () => {
//     if (typeof window !== 'undefined') {
//         window.addEventListener('popstate', () => {
//             const newLink = window.location.href;
//             console.log(newLink);
//             if (newLink.indexOf("/team") > -1) {
//                 return window.location.href = newLink;
//             }
//             return null;
//         }
//         )
//     }
//   }

// Wraps every page in a component
// exports.wrapPageElement = ({ element, props }) => {
//   return <Layout {...props}>{element}</Layout>
// }
